import { render, staticRenderFns } from "./SyntheticalData.vue?vue&type=template&id=2bd82e0d&scoped=true&"
import script from "./SyntheticalData.vue?vue&type=script&lang=js&"
export * from "./SyntheticalData.vue?vue&type=script&lang=js&"
import style0 from "./SyntheticalData.vue?vue&type=style&index=0&id=2bd82e0d&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd82e0d",
  null
  
)

export default component.exports